import opportunity from '@/api/opportunity'
import { getOpportunityEditionInfo } from '@/utils/validations'
import { ENABLED_EXTERNAL_END_POINT } from "@/constants";

export default {
  getNewOpportunity ({ commit }) {
    return opportunity.getNewOpportunity().then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        commit('SET_OPPORTUNITY_STATUS_DATA', response.data)
        commit('SET_OPPORTUNITY_DETAILS_DATA', response.data)
        commit('SET_CLIENT_DETAILS_DATA', response.data)
        commit('SET_STEP_SELECT_DATA', response.data)
        commit('SET_PERMISSIONS_DATA', response.data)
        commit('SET_FORMAT_TYPES_DATA', response.data)
        commit('SET_SOURCE_TYPES_DATA', response.data)
        return response.data
      }
      return response
    })
  },

  saveNewOpportunity ({ commit }, payload) {
    return opportunity.saveNewOpportunity(payload).then(response => {
      if (response && response.status === 200) {
        return response.data
      }
      return response
    })
  },

  async saveOpportunity ({ state, commit, dispatch }) {
    const payload = state.opportunity
    const { isModifiedDays, isModifiedRestOpportunity } = getOpportunityEditionInfo(state.opportunity, state.opportunityBackup)
    if (isModifiedDays && !isModifiedRestOpportunity && ENABLED_EXTERNAL_END_POINT) {
      const response = await opportunity.saveNewOpportunityByExtenal(payload)
      if ( response && response.status === 200) {
        const currentOpportunity = state.opportunity
        const updatedOpportunity = {
          ...currentOpportunity,
          itineraries: response.data.map(itinerary => ({
            ...itinerary,
            days: itinerary.days.map(day => ({
              ...day,
              isANewDay: false
            }))
          }))
        }
        commit('SET_OPPORTUNITY_DATA', updatedOpportunity)
        commit('SET_OPPORTUNITY_BACKUP', updatedOpportunity)

        await opportunity.publishOpportunity(updatedOpportunity)
      }
      return { stateUpdated: true }
    }
    return opportunity.saveNewOpportunity(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        localStorage.removeItem(payload.id);
        if (response.data.opportunity) {
          dispatch("setOpportunity", response.data.opportunity);
        }
        return response.data
      }
      return response
    })
  },

  searchOpportunity ({ commit }, payload) {
    return opportunity.searchOpportunity(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        return response.data.data
      }
      return response
    })
  },

  getOpportunity ({ state, commit, dispatch }, uuid) {
    return opportunity.getOpportunity(uuid).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        return dispatch("setOpportunity", response.data.data);
      }
      return response
    })
  },

  setOnlyOpportunity({ commit, state, getters }, data) {
    const opportunityData = {
      ...data,
      consumer_section: {
        ...data.consumer_section,
        twinshare_price_name: data.consumer_section.twinshare_price_name || 'Twin Share Price',
        single_supp_price_name: data.consumer_section.single_supp_price_name || 'Single Share Price',
      },
    }

    commit('SET_OPPORTUNITY_DATA', [])
    commit('SET_OPPORTUNITY_DATA', opportunityData)
    commit('SET_OPPORTUNITY_BACKUP', opportunityData)

    return opportunityData;
  },

  setOpportunity({ commit, state, getters, dispatch }, data) {
    const opportunityData = dispatch('setOnlyOpportunity', data);

    const indexItinerary = 0
    const sourceType = getters.sourceTypes[indexItinerary]
    commit('SET_SOURCE_TYPE_SELECTED', { sourceType, indexItinerary })

    return opportunityData;
  },

  saveOpportunityDataInLocalStorage ({ commit, state }, uuid) {
    const opportunity = state.opportunity
    if (opportunity) {
      const itineraries = opportunity.itineraries
      if (!Array.isArray(itineraries)) {
        opportunity.itineraries = []
        opportunity.itineraries.push(itineraries)
      }
      localStorage.setItem(uuid, JSON.stringify(opportunity))
      commit('SET_OPPORTUNITY_DATA', opportunity)
      return opportunity
    }
  },

  listOpportunities ({ commit }, payload) {
    return opportunity.listOpportunities(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        commit('SET_OPPORTUNITIES_SAVED_DATA', [])
        commit('SET_OPPORTUNITIES_SAVED_DATA', response.data.data)
        return response.data
      }
      return response
    })
  },

  listOpportunitiesSaved ({ commit }, payload) {
    return opportunity.listOpportunitiesSaved(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        commit('SET_OPPORTUNITIES_SAVED_DATA', [])
        commit('SET_OPPORTUNITIES_SAVED_DATA', response.data.data)
        return response.data
      }
      return response
    })
  },

  downloadQuotePDF ({ commit }, payload) {
    return opportunity.downloadQuotePDF(payload).then(response => {
      let fileURL = window.URL.createObjectURL(new Blob([response.data]))

      if (!payload.preview_section) {
        let fileLink = document.createElement('a')
        let fileName = `${payload.uuid}.pdf`

        fileLink.href = fileURL
        fileLink.setAttribute('download', fileName)
        document.body.appendChild(fileLink)

        fileLink.click()
      }

      return fileURL
    })
  },

  downloadFlyerPDF ({ commit }, payload) {
    return opportunity.downloadFlyerPDF(payload).then(response => {
      let fileURL = window.URL.createObjectURL(new Blob([response.data]))

      if (!payload.preview_section && !payload.preview) {
        let fileLink = document.createElement('a')
        let fileName = `${payload.uuid}.pdf`

        fileLink.href = fileURL
        fileLink.setAttribute('download', fileName)
        document.body.appendChild(fileLink)

        fileLink.click()
      }

      return fileURL
    })
  },

  duplicateOpportunity ({ commit }, payload) {
    return opportunity.duplicateOpportunity(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        return response
      }
      return response
    })
  },

  deleteOpportunity ({ commit }, payload) {
    return opportunity.deleteOpportunity(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        return response.data
      }
      return response
    })
  },

  suggestImages ({ commit }, payload) {
    return opportunity.suggestImages(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        return response.data
      }
      return response
    })
  },

  searchSignature ({ commit }, payload) {
    return opportunity.searchSignature(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        commit('SET_SIGNATURE', response.data.data)
        return response.data.data
      }
      return response
    })
  },

  processSignature ({ commit }, payload) {
    return opportunity.processSignature(payload).then(response => {
      if (
        response &&
        response.status === 200 &&
        response.data.status === true
      ) {
        return response.data.data
      }
      return response
    })
  }
}
